/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passkeys_TitleInputs */

const en_passkeys_title = /** @type {(inputs: Passkeys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkeys`)
};

const de_passkeys_title = /** @type {(inputs: Passkeys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkeys`)
};

/**
* | output |
* | --- |
* | "Passkeys" |
*
* @param {Passkeys_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const passkeys_title = /** @type {((inputs?: Passkeys_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkeys_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_passkeys_title(inputs)
	return en_passkeys_title(inputs)
});